/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import { useIntl } from "react-intl";

import { useTheme } from "../../../../../config/emotion";
import EwaButton2 from "../EwaButton/EwaButton2";
import { PurposedButtonProps } from "../types";
import { labellessButtonCss } from "../styles";

type Props = {
  onClick: () => void;
};

const UserFilterToggleButton: FC<PurposedButtonProps> = (props) => {
  const intl = useIntl();
  const { colors } = useTheme();

  const iconName = !props.appliedFilters ? "filter_alt" : "filter_alt_off";

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      iconName={iconName}
      tooltip={intl.formatMessage({ id: "table.user_filter" })}
      css={labellessButtonCss}
      dataCy="user-filter-button"
      {...props}
    />
  );
};

export default UserFilterToggleButton;
export type UserFilterToggleButtonProps = Props;
